import { extractQueryState } from "@shared/utils/extractQueryState";
import { useQuery } from "@tanstack/react-query";
import { getActionsAppsApiClient } from "@shared/apis/sidekick/api-factories";
import { AppsControllerListAllApps200ResponseInner } from "@shared/apis/sidekick/generated";

type Props = {
  onSuccess?: (data: AppsControllerListAllApps200ResponseInner[]) => void;
};

export const GET_CONNECTED_APPS_QUERY_KEY = "actions-apps";

export const useGetActionsApps = (params?: Props) => {
  const { onSuccess } = params || {};

  const api = getActionsAppsApiClient();
  const query = useQuery({
    queryKey: [GET_CONNECTED_APPS_QUERY_KEY],
    queryFn: async () => {
      try {
        const response = await api.appsControllerListAllApps();
        onSuccess?.(response);
        return response;
      } catch (e) {
        console.error("Failed to get apps.", e);
        throw e;
      }
    },
  });

  return extractQueryState(query);
};
